export const BONUS_MESSAGE_TYPE = 'bonus';
export const NEWS_MESSAGE_TYPE = 'news';
export const PROMO_MESSAGE_TYPE = 'promo';
export const SUPPORT_MESSAGE_TYPE = 'support';
export const SPORT_MESSAGE_TYPE = 'sport';
export const CASINO_MESSAGE_TYPE = 'casino';
export const ALL_FILTER_TYPE = 'all';

export const MESSAGE_ICON_BY_TYPE = {
  [BONUS_MESSAGE_TYPE]: 'icons/user_menu/bonuses',
  [NEWS_MESSAGE_TYPE]: 'icons/general/state/news',
  [PROMO_MESSAGE_TYPE]: 'icons/nav_menu/promos',
  [SUPPORT_MESSAGE_TYPE]: 'icons/general/state/settings',
  [SPORT_MESSAGE_TYPE]: 'icons/sport/id-1',
  [CASINO_MESSAGE_TYPE]: 'icons/general/state/ic-casino'
};

export const UNREAD_MESSAGE_TYPE = 'unread';
export const READ_MESSAGE_TYPE = 'read';

export const DATE_FILTER = [
  {
    value: '2',
    label: 'web.personaloffice.messages.filters.dates.todayandyesterday'
  },
  {
    value: '7',
    label: 'web.personaloffice.messages.filters.dates.7days'
  },
  {
    value: '30',
    label: 'web.personaloffice.messages.filters.dates.30days'
  },
  {
    value: '90',
    label: 'web.personaloffice.messages.filters.dates.90days'
  }
];

export const CATEGORIES_FILTER = [
  {
    value: 'news',
    label: 'web.personaloffice.messages.filters.category.news'
  },
  {
    value: 'promo',
    label: 'web.personaloffice.messages.filters.category.promo'
  },
  {
    value: 'support',
    label: 'web.personaloffice.messages.filters.category.support'
  },
  {
    value: 'bonus',
    label: 'web.personaloffice.messages.filters.category.bonuses'
  },
  {
    value: 'sport',
    label: 'web.personaloffice.messages.filters.category.sport'
  },
  {
    value: 'casino',
    label: 'web.personaloffice.messages.filters.category.casino'
  },
  {
    value: 'all',
    label: 'web.personaloffice.messages.filters.category.all'
  }
];

export const STATUS_FILTER = [
  {
    value: 'read',
    label: 'web.personaloffice.messages.filters.status.read'
  },
  {
    value: 'unread',
    label: 'web.personaloffice.messages.filters.status.unread'
  },
  {
    value: 'all',
    label: 'web.personaloffice.messages.filters.category.all'
  }
];
